module.exports = __webpack_public_path__ + "_assets/img/profile-04.445f6930.svg";